import { FunctionComponent } from 'react';
import { DocumentCites } from '@openlaw-au/types';

interface Props {
  section: string;
  numCitationsMap?: Record<string, number>;
  callback?: (value: any) => void;
}

const CitationRenderer: FunctionComponent<Props> = ({
  section,
  numCitationsMap,
  callback,
}) => {

  if (!numCitationsMap || numCitationsMap[section] < 1) {
    return null;
  }

  const numCites = numCitationsMap[section];
  if (!callback) {
    // console.log(section);
    // console.log(numCites);
  }

  if (!numCites) {
    return null;
  }

  return (
    <div
      className="flex h-8 w-8 hover:cursor-pointer hover:opacity-60"
      onClick={() => callback && callback(section)}
    >
      <img
        src="/arrow.svg"
        width={100}
        height={100}
        alt="Citation"
        className="ml-16"
      />
      <div className="flex h-8 w-12">
        <div className="p-1 px-2 ml-1 bg-[#EBC67E] font-bold text-md rounded-sm">
          {numCites}
        </div>
        <div className="invisible lg:visible p-1 px-4 bg-[#F9F5F5] font-light text-black">
          Citations
        </div>
      </div>
    </div>
  );
};

export default CitationRenderer;
